/* =========================================================
   NVQ PDP — gedrag van de productpagina (versie 2)
   Hoort bij: sections/nvq-product.liquid + assets/nvq-pdp.css

   Wat dit bestand doet:
     1. varianten kiezen (kleur + maat) en de galerij meesturen
     2. het koopformulier versturen zonder de pagina te verlaten
     3. Kaching Bundles op de hoogte houden van de gekozen variant
     4. "Komplettera looken": meerdere producten in een keer toevoegen
     5. de zwevende koopbalk tonen zodra de knop uit beeld is
     6. accordeons open- en dichtklappen, ook vanaf de maattabel-link

   Over Kaching: de app leest de variant uit het adres (?variant=) en uit
   het verborgen veld name="id" in het formulier, en hangt zich aan elk
   verzoek naar /cart/add om de gekozen bundel mee te sturen. Daarom
   versturen we het echte formulier en houden we die twee bij.

   Het winkelmandje opent vanzelf: nvq-cart-drawer.js luistert al mee op
   elk verzoek naar /cart/add.
   ========================================================= */
(function () {
  'use strict';

  var ROOT = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/$/, '');

  /* ---------------------------------------------------------
     Geld opmaken. We rekenen in hele centen en laten de browser
     er de juiste valuta van maken.
     --------------------------------------------------------- */
  function makeMoney(currency, locale) {
    var fmt = null;
    try {
      fmt = new Intl.NumberFormat(locale === 'sv' ? 'sv-SE' : (locale || 'sv-SE'), {
        style: 'currency',
        currency: currency || 'SEK',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    } catch (e) {
      fmt = null;
    }
    return function (cents) {
      var amount = (Number(cents) || 0) / 100;
      if (fmt) return fmt.format(amount);
      return amount.toFixed(2) + ' ' + (currency || '');
    };
  }

  function parseJSON(el) {
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function on(el, type, fn) { if (el) el.addEventListener(type, fn); }
  function all(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  /* =========================================================
     De productpagina
     ========================================================= */
  function initProduct(root) {
    if (root.__nvqPdpReady) return;
    root.__nvqPdpReady = true;

    var data = parseJSON(root.querySelector('[data-pdp-data]'));
    if (!data) return;

    var money = makeMoney(data.currency, data.locale);
    var variants = data.variants || [];

    function announce(message) {
      var box = root.querySelector('[data-pdp-error]');
      if (box) box.textContent = message || '';
    }

    /* Beginvariant: die uit de URL, anders de eerste leverbare. */
    var current = findById(data.selected_id) ||
      variants.filter(function (v) { return v.available; })[0] || variants[0];
    if (!current) return;
    var chosen = current.options.slice();

    function findById(id) {
      id = Number(id);
      for (var i = 0; i < variants.length; i++) if (variants[i].id === id) return variants[i];
      return null;
    }

    function findByOptions(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], hit = true;
        for (var j = 0; j < opts.length; j++) {
          if (v.options[j] !== opts[j]) { hit = false; break; }
        }
        if (hit) return v;
      }
      return null;
    }

    /* Bestaat er bij de huidige keuze een leverbare variant met waarde X
       op positie P? Alleen de opties vóór P tellen mee, zodat de kleur
       bepaalt welke maten doorgestreept worden en niet andersom. */
    function availableFor(position, value) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (v.options[position] !== value) continue;
        var ok = true;
        for (var p = 0; p < position; p++) {
          if (v.options[p] !== chosen[p]) { ok = false; break; }
        }
        if (ok && v.available) return true;
      }
      return false;
    }

    function firstValidValue(position) {
      var fallback = null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var p = 0; p < position; p++) {
          if (v.options[p] !== chosen[p]) { ok = false; break; }
        }
        if (!ok) continue;
        if (v.available) return v.options[position];
        if (fallback === null) fallback = v.options[position];
      }
      return fallback;
    }

    /* ---------- Galerij ----------
       Desktop: foto's op elkaar gestapeld, de opmaak laat ze in elkaar
       overvloeien en wij zetten alleen data-active. Mobiel: een echte
       swipestrook. Een strook met scroll-snap is via code niet betrouwbaar
       te verschuiven, daarom zetten we het vastklikken even uit. */
    var track = root.querySelector('[data-pdp-track]');
    var slides = track ? all(track, '[data-pdp-slide]') : [];
    var thumbs = all(root, '[data-pdp-thumb]');
    var dots = all(root, '[data-pdp-dot]');
    var activeIndex = 0;
    var snapTimer = null;
    var movingByScript = false;

    function isScrollable() { return !!track && track.scrollWidth > track.clientWidth + 1; }

    function markIndex(index) {
      thumbs.forEach(function (t, i) { t.setAttribute('aria-current', i === index ? 'true' : 'false'); });
      dots.forEach(function (d, i) { d.setAttribute('aria-current', i === index ? 'true' : 'false'); });
    }

    function goToIndex(index) {
      if (!track || index < 0 || index >= slides.length) return;
      activeIndex = index;
      markIndex(index);
      slides.forEach(function (slide, i) { slide.setAttribute('data-active', i === index ? 'true' : 'false'); });
      if (!isScrollable()) return;

      movingByScript = true;
      track.style.scrollSnapType = 'none';
      void track.scrollLeft;
      var left = slides[index].offsetLeft;
      try { track.scrollTo({ left: left, behavior: 'instant' }); } catch (e) { track.scrollLeft = left; }
      clearTimeout(snapTimer);
      snapTimer = setTimeout(function () {
        track.style.scrollSnapType = '';
        movingByScript = false;
      }, 120);
    }

    function goToMedia(mediaId) {
      if (!mediaId) return;
      for (var i = 0; i < slides.length; i++) {
        if (String(slides[i].getAttribute('data-media-id')) === String(mediaId)) { goToIndex(i); return; }
      }
    }

    function step(dir) {
      var next = activeIndex + dir;
      if (next < 0) next = slides.length - 1;
      if (next >= slides.length) next = 0;
      goToIndex(next);
    }

    thumbs.forEach(function (t, i) { on(t, 'click', function () { goToIndex(i); }); });
    dots.forEach(function (d, i) { on(d, 'click', function () { goToIndex(i); }); });
    on(root.querySelector('[data-pdp-prev]'), 'click', function () { step(-1); });
    on(root.querySelector('[data-pdp-next]'), 'click', function () { step(1); });

    if (track) {
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking || movingByScript) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          var best = 0, min = Infinity;
          for (var i = 0; i < slides.length; i++) {
            var d = Math.abs(slides[i].offsetLeft - track.scrollLeft);
            if (d < min) { min = d; best = i; }
          }
          activeIndex = best;
          markIndex(best);
          ticking = false;
        });
      }, { passive: true });
    }

    /* ---------- Variantknoppen ---------- */
    var optionBtns = all(root, '[data-opt-btn]');

    function pickOption(pos, value) {
      chosen[pos] = value;

      /* Bestaat de combinatie niet of is hij op, dan schuiven we de latere
         opties door naar de eerste waarde die wel leverbaar is. Zo komt een
         klant nooit op een dood eind uit. */
      var match = findByOptions(chosen);
      if (!match || !match.available) {
        for (var p = pos + 1; p < chosen.length; p++) {
          var fix = firstValidValue(p);
          if (fix !== null) chosen[p] = fix;
        }
        match = findByOptions(chosen) || match;
      }
      if (match) setVariant(match, true);
    }

    optionBtns.forEach(function (btn) {
      on(btn, 'click', function () {
        pickOption(parseInt(btn.getAttribute('data-opt-position'), 10), btn.getAttribute('data-opt-value'));
      });
    });

    /* Swatch King zet bij een klik de verborgen radioknop aan en stuurt een
       change-event. Dat vertalen we naar dezelfde keuze als onze eigen knoppen. */
    var skInputs = all(root, 'input[data-variant-input]');
    skInputs.forEach(function (input) {
      on(input, 'change', function () {
        if (!input.checked) return;
        var pos = parseInt(input.getAttribute('data-sk-position'), 10);
        if (chosen[pos] !== input.value) pickOption(pos, input.value);
      });
    });

    function paintOptionButtons() {
      optionBtns.forEach(function (btn) {
        var pos = parseInt(btn.getAttribute('data-opt-position'), 10);
        var value = btn.getAttribute('data-opt-value');
        btn.setAttribute('aria-pressed', chosen[pos] === value ? 'true' : 'false');
        btn.setAttribute('data-sold', availableFor(pos, value) ? 'false' : 'true');
      });
      skInputs.forEach(function (input) {
        input.checked = chosen[parseInt(input.getAttribute('data-sk-position'), 10)] === input.value;
      });
      all(root, '[data-opt-current]').forEach(function (el) {
        el.textContent = chosen[parseInt(el.getAttribute('data-opt-current'), 10)] || '';
      });
    }

    function hasCompare(v) {
      return data.show_compare && v.compare_at_price && v.compare_at_price > v.price;
    }

    function paintPrice() {
      var priceEl = root.querySelector('[data-pdp-price]');
      var compareEl = root.querySelector('[data-pdp-compare]');
      var saveEl = root.querySelector('[data-pdp-save]');
      var show = hasCompare(current);

      if (priceEl) priceEl.textContent = money(current.price);
      if (compareEl) {
        compareEl.textContent = show ? money(current.compare_at_price) : '';
        compareEl.hidden = !show;
      }
      if (saveEl) {
        if (show) {
          var pct = Math.round((1 - current.price / current.compare_at_price) * 100);
          saveEl.textContent = (saveEl.getAttribute('data-template') || '−{percent} %').replace('{percent}', pct);
        }
        saveEl.hidden = !show;
      }
    }

    var form = root.querySelector('[data-pdp-form]');
    var idInput = root.querySelector('[data-pdp-id]');
    var atc = root.querySelector('[data-pdp-atc]');

    function paintButton() {
      if (!atc) return;
      atc.disabled = !current.available;
      atc.textContent = current.available
        ? (atc.getAttribute('data-label') || 'Lägg i varukorgen')
        : (atc.getAttribute('data-sold-label') || 'Slutsåld');
    }

    /* fromPicker: true als de klant zelf op onze knoppen klikte. Komt de
       wijziging van Kaching (adres of formulierveld), dan sturen we niets
       terug, anders praten de twee eindeloos tegen elkaar in. */
    function setVariant(variant, fromPicker) {
      if (!variant) return;
      var changed = !current || current.id !== variant.id;
      current = variant;
      chosen = variant.options.slice();

      paintOptionButtons();
      paintPrice();
      paintButton();
      syncFloat();
      if (changed) goToMedia(variant.media_id);

      if (idInput && String(idInput.value) !== String(variant.id)) {
        idInput.value = variant.id;
        if (fromPicker) idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (fromPicker && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState(window.history.state, '', url.toString());
      }

      if (changed) document.dispatchEvent(new CustomEvent('nvq:pdp:variant', { detail: { variant: variant } }));
    }

    /* Kaching kan bij een bundel zelf de variant omzetten. Dat volgen we. */
    on(idInput, 'change', function () {
      var v = findById(idInput.value);
      if (v && v.id !== current.id) setVariant(v, false);
    });
    window.addEventListener('popstate', function () {
      var id = new URL(window.location.href).searchParams.get('variant');
      var v = id && findById(id);
      if (v && v.id !== current.id) setVariant(v, false);
    });

    /* ---------- In de winkelwagen leggen ----------
       Het formulier zelf versturen, als FormData. Kaching hangt er dan de
       bundel aan en het winkelmandje gaat vanzelf open. */
    function setBusy(button, state) {
      if (!button) return;
      if (state) button.setAttribute('data-busy', 'true');
      else button.removeAttribute('data-busy');
    }

    function postCart(body, isJson) {
      var headers = { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
      if (isJson) headers['Content-Type'] = 'application/json';
      return fetch(ROOT + '/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: headers,
        body: isJson ? JSON.stringify(body) : body
      }).then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (json) {
          if (!res.ok) throw new Error((json && (json.description || json.message)) || data.text_error);
          return json;
        });
      });
    }

    /* Kaching vangt het verzoek soms af voordat het winkelmandje het ziet.
       Staat het mandje na een kort moment nog dicht, dan vragen we het zelf
       om open te gaan. */
    function openCartIfClosed() {
      setTimeout(function () {
        var drawer = document.querySelector('[data-nvq-cd]');
        if (drawer && drawer.getAttribute('data-nvq-cd-open') === 'true') return;
        document.dispatchEvent(new CustomEvent('nvq:cart:open'));
      }, 900);
    }

    on(form, 'submit', function (event) {
      event.preventDefault();
      if (!current.available || (atc && atc.getAttribute('data-busy') === 'true')) return;
      announce('');
      setBusy(atc, true);
      postCart(new FormData(form), false)
        .then(openCartIfClosed)
        .catch(function (err) { announce(err.message || data.text_error); })
        .then(function () { setBusy(atc, false); });
    });

    /* ---------- Komplettera looken ---------- */
    var look = root.querySelector('[data-look]');
    if (look) {
      var lookItems = all(look, '[data-look-item]');
      var lookBtn = look.querySelector('[data-look-add]');

      function lookOption(item) {
        var field = item.querySelector('[data-look-variant]');
        if (!field) return null;
        if (field.tagName === 'SELECT') return field.options[field.selectedIndex] || null;
        return field;
      }

      function paintLook() {
        var count = 0, total = 0;
        lookItems.forEach(function (item) {
          var opt = lookOption(item);
          var check = item.querySelector('[data-look-check]');
          var price = opt ? Number(opt.getAttribute('data-price')) || 0 : 0;
          var compare = opt ? Number(opt.getAttribute('data-compare')) || 0 : 0;
          var priceEl = item.querySelector('[data-look-price]');
          var wasEl = item.querySelector('[data-look-was]');
          if (priceEl) priceEl.textContent = money(price);
          if (wasEl) {
            wasEl.hidden = !(compare > price);
            wasEl.textContent = compare > price ? money(compare) : '';
          }
          var isOn = !!(check && check.checked && opt);
          item.setAttribute('data-checked', isOn ? 'true' : 'false');
          if (isOn) { count += 1; total += price; }
        });
        if (!lookBtn) return;
        var tpl = count === 1 ? lookBtn.getAttribute('data-template-one') : lookBtn.getAttribute('data-template');
        lookBtn.textContent = (tpl || '').replace('{antal}', count).replace('{totaal}', money(total));
        lookBtn.disabled = count === 0;
      }

      look.addEventListener('change', paintLook);

      /* Kiest de klant boven een maat, dan zetten we bij de look-producten
         dezelfde maat klaar, met behoud van de kleur die er al stond. De
         eerste optie is bij ons altijd de kleur, dus die tellen we niet. */
      function followSize() {
        var wanted = chosen.slice(1);
        if (!wanted.length) return;
        lookItems.forEach(function (item) {
          var select = item.querySelector('select[data-look-variant]');
          if (!select) return;
          var keep = (select.options[select.selectedIndex] || {}).text || '';
          var keepParts = keep.split(' / ');
          var best = -1, bestScore = -1;
          Array.prototype.forEach.call(select.options, function (opt, i) {
            var parts = opt.text.split(' / ');
            var score = 0;
            parts.forEach(function (part, j) {
              if (wanted.indexOf(part) !== -1) score += 2;
              if (keepParts[j] === part) score += 1;
            });
            if (score > bestScore) { bestScore = score; best = i; }
          });
          if (best > -1 && best !== select.selectedIndex) select.selectedIndex = best;
        });
        paintLook();
      }
      document.addEventListener('nvq:pdp:variant', followSize);
      followSize();

      on(lookBtn, 'click', function () {
        if (lookBtn.getAttribute('data-busy') === 'true') return;
        var items = [];
        lookItems.forEach(function (item) {
          var opt = lookOption(item);
          var check = item.querySelector('[data-look-check]');
          if (check && check.checked && opt) items.push({ id: Number(opt.value), quantity: 1 });
        });
        if (!items.length) return;
        announce('');
        setBusy(lookBtn, true);
        postCart({ items: items }, true)
          .then(function () {
            openCartIfClosed();
            var done = lookBtn.getAttribute('data-done');
            if (done) {
              lookBtn.textContent = done;
              setTimeout(paintLook, 2400);
            }
          })
          .catch(function (err) { announce(err.message || data.text_error); })
          .then(function () { setBusy(lookBtn, false); });
      });

      paintLook();
    }

    /* ---------- Accordeons ---------- */
    function setAccordion(btn, open) {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      if (isOpen === open) return;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');

      if (!open) {
        /* Eerst de huidige hoogte vastleggen, dan pas naar nul. Het uitlezen
           van offsetHeight dwingt de browser die tussenstap af. */
        panel.style.height = panel.scrollHeight + 'px';
        void panel.offsetHeight;
        panel.style.height = '0px';
        return;
      }
      panel.style.height = panel.scrollHeight + 'px';
      var done = function () {
        panel.style.height = 'auto';
        panel.removeEventListener('transitionend', done);
        clearTimeout(panel.__nvqTimer);
      };
      panel.addEventListener('transitionend', done);
      /* Loopt de animatie niet (achtergrondtab, minder beweging), dan
         zetten we de hoogte alsnog los. */
      clearTimeout(panel.__nvqTimer);
      panel.__nvqTimer = setTimeout(done, 500);
    }

    all(root, '[data-acc-btn]').forEach(function (btn) {
      on(btn, 'click', function () { setAccordion(btn, btn.getAttribute('aria-expanded') !== 'true'); });
    });

    /* De maattabel-link onder de maten opent de maattabel als pop-up.
       Sluiten kan met het kruisje, Escape of een klik naast het venster. */
    var sgDialog = root.querySelector('[data-size-guide-dialog]');
    if (sgDialog && typeof sgDialog.showModal === 'function') {
      all(root, '[data-size-guide-open]').forEach(function (link) {
        on(link, 'click', function () {
          sgDialog.showModal();
          document.documentElement.setAttribute('data-nvq-sg-open', 'true');
        });
      });
      on(sgDialog.querySelector('[data-size-guide-close]'), 'click', function () { sgDialog.close(); });
      on(sgDialog, 'click', function (e) { if (e.target === sgDialog) sgDialog.close(); });
      on(sgDialog, 'close', function () { document.documentElement.removeAttribute('data-nvq-sg-open'); });
    }

    /* ---------- Zwevende koopbalk ---------- */
    var float = root.querySelector('[data-pdp-float]');
    var floatBtn = float ? float.querySelector('[data-float-add]') : null;
    var anchor = root.querySelector('[data-pdp-float-anchor]') || atc;

    function syncFloat() {
      if (!float) return;
      var img = float.querySelector('[data-float-image]');
      var priceEl = float.querySelector('[data-float-price]');
      var metaEl = float.querySelector('[data-float-meta]');
      if (img && current.image) img.src = current.image;
      if (priceEl) priceEl.textContent = money(current.price);
      if (metaEl) metaEl.textContent = chosen.filter(function (c) { return c && c !== 'Default Title'; }).join(' / ');
      if (floatBtn) {
        floatBtn.disabled = !current.available;
        floatBtn.textContent = current.available
          ? (floatBtn.getAttribute('data-label') || floatBtn.textContent)
          : (atc ? atc.getAttribute('data-sold-label') : floatBtn.textContent);
      }
    }
    if (floatBtn) floatBtn.setAttribute('data-label', floatBtn.textContent.trim());

    /* De balk verschijnt zodra de klant voorbij de koopknop is gescrold.
       Bewust geen IntersectionObserver: die meldt pas iets als de knop een
       keer in beeld is geweest, en bij een pagina die al halverwege opent
       gebeurt dat nooit. */
    function updateFloat() {
      if (!float || !anchor) return;
      var open = anchor.getBoundingClientRect().bottom <= 0;
      float.setAttribute('data-open', open ? 'true' : 'false');
      float.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (floatBtn) floatBtn.tabIndex = open ? 0 : -1;
    }

    /* De balk verstuurt hetzelfde formulier, zodat een gekozen Kaching-
       bundel ook vanaf hier meegaat. */
    on(floatBtn, 'click', function () {
      if (!form || !current.available) return;
      if (typeof form.requestSubmit === 'function') form.requestSubmit(atc || undefined);
      else if (atc) atc.click();
    });

    if (float && anchor) {
      window.addEventListener('scroll', updateFloat, { passive: true });
      window.addEventListener('resize', updateFloat);
      updateFloat();
    }

    /* ---------- Eerste keer tekenen ---------- */
    paintOptionButtons();
    paintPrice();
    paintButton();
    syncFloat();
    markIndex(0);
    goToMedia(current.media_id);
  }

  /* =========================================================
     Opstarten, ook na een wijziging in de thema-editor
     ========================================================= */
  function boot(scope) {
    all(scope || document, '[data-nvq-pdp]').forEach(initProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();
